export default __webpack_public_path__ + "static/media/social-home.1dbc1d0c.png";